import { SET_SHOW_PRICING } from '../actions/types';

export default function settings(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_SHOW_PRICING:
				return {
					...state,
					showPricing: action.payload.showPricing
				};

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js